import { Component, OnInit, EventEmitter } from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';
import { Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import * as _ from 'lodash';

declare var Materialize: any;
declare var $: any;
@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.css']
})
export class GatewayComponent implements OnInit {

  casedata = 0;
  detail_modal = new EventEmitter<string | MaterializeAction>();
  soon_modal = new EventEmitter<string | MaterializeAction>();
  consent_policy = new EventEmitter<string | MaterializeAction>();
  pdf_result = new EventEmitter<string | MaterializeAction>();
  loading: boolean = false;

  FileDetail:any;
  FileDetail1:any;
  FileDetail2:any;
  pdfview:SafeResourceUrl;
  pdfview1:SafeResourceUrl;
  pdfview2:SafeResourceUrl;

  accept = false;

  DoctorName="";
  ClinicName="";
  Contact;
  Email;

  LawyerName="";
  FirmName="";
  Lawyer_Contact;
  Laywer_Email;

  DataResult:any;

  FixedColumn;
  FilterDataResult;
  treatments_list:any;
  Result_data:any;

  constructor(private router : Router,private apirequest: ApiRequestService,private sanitizer:DomSanitizer) { }

  ngOnInit() {
    // this.cases();
    // console.log(this.DataResult);
  }


  medico(){
    this.router.navigate(['/user/medico_legal']);
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  cases(){
    // console.log(keyword);
    let input;
   
    input =  {action:"get_all_case_no",case_number:""};
    
    
    this.apirequest.case(input).subscribe(res => {
      // console.log(res.msg);
      
      if(res.status === "True") {
        this.casedata = 1;
        localStorage.setItem("cases",JSON.stringify(res.msg));
      } else if(res.status === "False") {
          this.msg_view(res.msg);
      }       
    });
  }
  


  DetailModalOpen(){
    this.detail_modal.emit({action: 'modal', params: ['open']});
    setTimeout(() => {
      $(document).ready(function(){
        $('ul.tabs').tabs();
      });
    }, 10);
  }
  DetailModalClose(){
    this.detail_modal.emit({action: 'modal', params: ['close']});
  }

  SoonModalOpen(){
    this.soon_modal.emit({action: 'modal', params: ['open']});
  }
  SoonModalClose(){
    this.soon_modal.emit({action: 'modal', params: ['close']});
  }

  ConsentModalClose(){
    this.consent_policy.emit({action: 'modal', params: ['close']});
  }
  ConsentModalOpen(){
    this.consent_policy.emit({action: 'modal', params: ['open']});
  }

  OpenPolicy(){
    this.DetailModalClose();
    this.ConsentModalOpen();
  }
  ClosePolicy(){
    this.ConsentModalClose();
    this.DetailModalOpen();
  }

  ResultModalOpen(){
    this.pdf_result.emit({action: 'modal', params: ['open']});
  }
  ResultModalClose(){
    this.pdf_result.emit({action: 'modal', params: ['close']});
  }

  onChange(file:any){
    this.FileDetail = file;
    let url = URL.createObjectURL(this.FileDetail);    
    this.pdfview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  onChange1(file:any){
    this.FileDetail1 = file;
    let url = URL.createObjectURL(this.FileDetail1);    
    this.pdfview1 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  onChange2(file:any){
    this.FileDetail2 = file;
    let url = URL.createObjectURL(this.FileDetail2);    
    this.pdfview2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  Submit(){

    console.log(this.FileDetail);
    this.loading = true;    
    let input = new FormData();
    input.append('action', 'save_form_data');
    input.append('Patient_Consent_Form', this.FileDetail);
    input.append('Patient_Medical_History', this.FileDetail1);
    input.append('Authorization_Request', this.FileDetail2);
   this.apirequest.customize_flow(input).subscribe(res => {    
    if(res.status === "True") {
      let a = res.Authorization_Request_Response;
      let b = res.Patient_Consent_Form_Response;
      let c = res.Patient_Medical_History_Response;
      var d = a.concat(b, c);
      this.treatments_list = _.uniq(d)
      console.log(this.treatments_list);
      if(this.treatments_list.length == 0 ){
        this.reset_form();
        this.DetailModalClose();
        this.loading = false;
      } else {
        this.APICall()      
      }
      this.msg_view(res.msg);
    } else if(res.status === "False") {
        this.msg_view(res.msg);
    }       
  });
   
  }

  reset_form(){
    this.FileDetail = undefined;
    this.FileDetail1 = undefined;
    this.FileDetail2 = undefined;
    $(document).ready(function(){
      $("#FileInput").val("");
      $("#FileInput1").val("");
      $("#FileInput2").val("");
  });
  }

  reset_patients(){
    this.accept = false;
    this.reset_patient();
  }

  reset_patient(){
    this.DoctorName = "";
    this.ClinicName = "";
    this.Contact = undefined;
    this.Email = undefined;
    this.LawyerName = "";
    this.FirmName = "";
    this.Lawyer_Contact = undefined;
    this.Laywer_Email = undefined;
  }

  reset_laywer(){
    this.FileDetail = undefined;
    this.FileDetail2 = undefined;
    $(document).ready(function(){
      $("#FileInput4").val("");
      $("#FileInput5").val("");
  });
    this.reset_patient();
  }

  ValidateValue(){
    console.log(this.accept);
    if(this.accept == true){
      setTimeout(() => {
        this.ClosePolicy();  
      }, 500);      
    } else if(this.accept == false){
      this.reset_patient();
    }       
  }

  Submit_Patient(){
    this.loading = true;    
    let input = {
      action:'patient',
      doctor:this.DoctorName,
      clinic:this.ClinicName,
      doctor_contact:this.Contact,
      doctor_email:this.Email,
      laywer:this.LawyerName,
      firm:this.FirmName,
      lawyer_contact:this.Lawyer_Contact,
      lawyer_email:this.Laywer_Email
    };
    console.log(input);
    
   this.apirequest.customize_flow(input).subscribe(res => {    
    if(res.status === "True") {
      this.msg_view(res.msg);

      this.reset_patients();
      this.DetailModalClose();
      this.loading = false;
    } else if(res.status === "False") {
        this.msg_view(res.msg);
    }       
  });

  }


  Submit_Lawyer(){
    this.loading = true;    
    let input = new FormData();
    input.append('action', 'lawyer');
    input.append('Patient_Consent_Form', this.FileDetail);
    input.append('Authorization_Request', this.FileDetail2);
    input.append('doctor',this.DoctorName);
    input.append('doctor_contact',this.Contact);
    input.append('doctor_email',this.Email);
    input.append('clinic',this.ClinicName);

    
   this.apirequest.customize_flow(input).subscribe(res => {    
    if(res.status === "True") {
      console.log(res);
      
      let a = res.Authorization_Request_Response;
      let b = res.Patient_Consent_Form_Response;
      var d = a.concat(b);
      this.treatments_list = _.uniq(d)
      console.log(this.treatments_list);
      if(this.treatments_list.length == 0 ){
        this.reset_form();
        this.DetailModalClose();
        this.loading = false;
      } else {
        this.APICall2()      
      }
      this.msg_view(res.msg);
    } else if(res.status === "False") {
        this.msg_view(res.msg);
    }       
  });
   
  }


  setTableData(){
    this.FilterDataResult = this.DataResult;
    this.FixedColumn = Object.keys(this.DataResult[0]);
    console.log(this.FixedColumn);    
  }

  APICall(){
    let data = {
      action: "search_portal_query",
      body_part: "lumbar",
      decision: "all",
      treatment: this.treatments_list,
      case_no: 10,
      startdate: "",
      enddate: "",
      details_list:['Final Determination']

    }
    console.log(data);

    this.apirequest.customize_flow(data).subscribe(res => {    
      if(res.status === "True") {
        console.log(res);
        this.Result_data = res.msg;
        this.DataResult = res.msg.data;
        this.setTableData();
        this.reset_form();
        this.DetailModalClose();
        this.loading = false;
        this.ResultModalOpen();
        
      } else if(res.status === "False") {
          this.msg_view(res.msg);
      }       
    });
  }

  APICall2(){
    let data = {
      action: "search_portal_query",
      body_part: "lumbar",
      decision: "all",
      treatment: this.treatments_list,
      case_no: 10,
      startdate: "",
      enddate: "",
      details_list:['Final Determination']

    }
    console.log(data);

    this.apirequest.customize_flow(data).subscribe(res => {    
      if(res.status === "True") {
        console.log(res);
        this.Result_data = res.msg;
        this.DataResult = res.msg.data;
        this.setTableData();
        this.reset_laywer();
        this.DetailModalClose();
        this.loading = false;
        this.ResultModalOpen();
        
      } else if(res.status === "False") {
          this.msg_view(res.msg);
      }       
    });
  }
  
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/gateway/gateway.component.ts